import React from "react";
import { Row, Col, Tabs, Tab } from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import {initDeepLinkData} from "../../utilities/sdk-doc-utils";
import EntityHandler from "js/utilities/entity-handler"

/**
 * Just a simple  component that is meant to go inline with form elements but only display static data
 */
export default React.createClass({
  render(){
    return(
      <div className="form-row form-row-static">
        {this.props.label && <span className="form-label">{this.props.label}: </span> }
        <span className="form-value">{this.props.value}</span>
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/js/components/account/account-form-static.jsx